import Cookies from 'js-cookie';
import { LOGIN_ROUTE } from '../constants/RouteNameConstants';
import { trackEvent } from './ga';

export const UserLogout = () => {
  sessionStorage.clear();
  Cookies.remove('userDataProofreader');
  Cookies.remove('sessionExpireModalOpenProofreader');
  trackEvent('proofreader_logout');
  window.location.href = LOGIN_ROUTE;
};
